module.exports = __webpack_public_path__ + "img/shopkeepSigilIcon.bea86038.png";